<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<div class="page-indicator">
    <div *ngIf="serviceFlag && claimsDataService.lossCauseTypesLoaded" class="claims-track-page-title-wrap claims-track-page-title--overview">
        Incident Details
        <small class="claims-track-company">
            <strong style="text-transform:uppercase;" *ngIf="lossCause">{{claimsDataService.getLossCause(claimInfo.lossCause)}}</strong>
            ({{claimInfo.claimNumber}})
            <strong style="text-transform:uppercase;">{{claimInfo.claimState}}</strong>
            <span *ngIf="claimInfo.incidentOnly">(Record Only)</span>
        </small>
        <small class="claims-track-number">Incident date: {{claimInfo.lossDate| date:'MM/dd/yyyy'}}</small>
    </div>
</div>
<div class="content-container-light-blue bolt-space-bottom-sm">
    <main class="content-container-light-blue__inner" role="main">
        <h2 class="tooltip__wrapfix" style="margin-bottom:5px;font-weight:bold;font-size:1.15em;text-transform:uppercase;">Claim Details
            <a id="tooltip_claimDetails" aria-label="tooltip claimDetails" role="button" class="nw-inline-help nw-icon-inline-help" [ngClass]="{'collapsed': !toolTipVars.claimDetailsHelptext1}"
                (click)="toolTipVars.claimDetailsHelptext1 = !toolTipVars.claimDetailsHelptext1"></a>
        </h2>
        <div class="nw-inline-help__content-container" [ngClass]="{'open': toolTipVars.claimDetailsHelptext1}" id="claimDetails_content">
            <div class="nw-inline-help__content">
                If you would like to make any updates to the following information, please contact your claims
                representative.
            </div>
        </div>
        <article class="claims-track-claim-content__text-box claims-track-claim__details">
            <section class="claims-track-claim-estimates">
                <div *ngIf="reportedDate" class="claims-track-claim-estimates__row">
                    <div>Reported on:</div>
                    <div>{{claimInfo.reportedDate| date:'longDate'}}</div>
                </div>
                <div *ngIf="displayName" class="claims-track-claim-estimates__row">
                    <div>Reported by:</div>
                    <div>{{claimInfo.claimReporter.reportedBy.displayName}}</div>
                </div>
                <div *ngIf="relationToInsured" class="claims-track-claim-estimates__row">
                    <div>Role of reporter:</div>
                    <div>{{claimInfo.claimReporter.relationToInsured}}</div>
                </div>
                <div *ngIf="lossDate" class="claims-track-claim-estimates__row">
                    <div>Incident Date:</div>
                    <div>{{claimInfo.lossDate| date:'longDate'}}</div>
                </div>
                <div *ngIf="lossLocation" class="claims-track-claim-estimates__row">
                    <div>Incident Location:</div>
                    <div>{{claimInfo.lossLocation.addressLine1}}, {{getLocation(claimInfo.lossLocation)}}</div>
                </div>
                <div *ngIf="hasPremisis" class="claims-track-claim-estimates__row">
                    <div>Premises ID:</div>
                    <div [ngClass]="{'no-premisis-id': claimsDataService.isSearching()}">
                        {{claimsDataService.getPremisisID()}}</div>
                </div>
                <div *ngIf="jurisdictionState" class="claims-track-claim-estimates__row">
                    <div>Jurisdiction state:</div>
                    <div>{{claimInfo.jurisdictionState}}</div>
                </div>
                <div *ngIf="lossCause" class="claims-track-claim-estimates__row">
                    <div>Type of claim:</div>
                    <div>{{claimsDataService.getLossCause(claimInfo.lossCause)}}</div>
                </div>
                <div *ngIf="policeNotified" class="claims-track-claim-estimates__row">
                    <div>Police/fire notified:</div>
                    <div *ngIf="claimInfo.policeNotified">Yes</div>
                    <div *ngIf="!claimInfo.policeNotified">No</div>
                </div>
            </section>
            <small style="margin-top: 20px;display:block" *ngIf="isWC">If there were any injuries, please contact your
                assigned claims associate for information about an injury related
                claim.
            </small>
        </article>
    </main>
</div>
<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
